import {Divider, Skeleton, Stack} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import React from 'react';
import {StyledCard} from './styles';

export const LoadingSkeleton = () => {
	const {isMobile} = useMediaQueries();
	return (
		<StyledGrid.Root spacing={2}>
			{Array.from({length: isMobile ? 2 : 3}).map((_, index) => (
				<StyledGrid.Item key={index} xs={12} sm={12} md={6} lg={4} xl={4}>
					<StyledCard>
						<Stack width={'100%'} gap={2}>
							<Skeleton
								variant="rectangular"
								height={30}
								width={148}
								sx={{mt: 2, ml: 2}}
							/>

							<Divider />

							<Stack gap={1} px={2}>
								<Skeleton variant="rectangular" height={14} width={100} />
								<Skeleton variant="rectangular" height={18} width="100%" />
							</Stack>

							<Stack gap={1} px={2}>
								<Skeleton variant="rectangular" height={14} width={100} />
								<Skeleton variant="rectangular" height={18} width="100%" />
							</Stack>

							<Stack gap={1} pb={2} px={2}>
								<Skeleton variant="rectangular" height={14} width={100} />
								<Skeleton variant="rectangular" height={18} width="100%" />
							</Stack>
						</Stack>
					</StyledCard>
				</StyledGrid.Item>
			))}
		</StyledGrid.Root>
	);
};
